var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.attributes.src,"srcset":_vm.srcset || _vm.attributes.srcset,"sizes":_vm.sizes || _vm.attributes.sizes,"width":_vm.width || _vm.attributes.width,"height":_vm.height || _vm.attributes.height}})}
var staticRenderFns = []

export { render, staticRenderFns }